// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2AUXV","balanceDisclaimer":"posDashboard_balanceDisclaimer__KQJxz"};